export const userControl = {
  el: {
    root: document.querySelector('.user-control'),
    trigger: document.querySelector('.user-control__trigger'),
  },

  init: () => {
    if (userControl.el.root) {
      userControl.el.trigger.addEventListener('click', userControl.toggleDropdown)
    }
  },

  isDropdownActive: () => userControl.el.root.classList.contains('user-control--open'),

  toggleDropdown: (event) => {
    event.preventDefault()

    if (userControl.isDropdownActive()) {
      userControl.el.root.classList.remove('user-control--open')
    } else {
      userControl.el.root.classList.add('user-control--open')
      document.addEventListener('click', userControl.toggleDropdownOnOutsideClick)
    }
  },

  toggleDropdownOnOutsideClick: (event) => {
    // const isThisOpen = event.target.closest('.filter--open')
    const isThisOpen = event.target.closest(`.${userControl.el.root.classList[0]}`) === userControl.el.root

    if (userControl.isDropdownActive() && !isThisOpen) {
      userControl.el.root.classList.remove('user-control--open')
      document.removeEventListener('click', userControl.toggleDropdownOnOutsideClick)
    }
  },
}
